import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ToastService } from 'core/services';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [],
  exports: [TranslateModule],
  providers: [ToastService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ImageCropperModule {
  constructor() {}
}
